import { IntlProvider } from "react-intl"
import flattenJson from "../../helpers/flattenJson"
import { messages } from "../../../../config/locales/react/messages"
import "./addLocaleData"

const DEFAULT_LOCALE = "en"

function withI18n(Component) {
  class ReactIntlContainer extends React.Component {
    state = {
      locale: DEFAULT_LOCALE,
    }

    componentWillMount() {
      let locale = DEFAULT_LOCALE

      if (this.props.location.state) {
        locale = this.props.location.state.locale
      }

      this.setState({ locale: locale || DEFAULT_LOCALE })
    }

    updateLanguage = (locale) => this.setState({ locale })

    static defaultProps = {
      i18n_locale: DEFAULT_LOCALE,
    }

    render() {
      const i18nMessages =
        this.state.locale === DEFAULT_LOCALE
          ? flattenJson(messages.en)
          : Object.assign(
            {},
            flattenJson(messages[DEFAULT_LOCALE]),
            flattenJson(messages[this.state.locale])
          )
      return (
        <IntlProvider
          locale={this.state.locale}
          messages={i18nMessages}
        >
          <Component
            {...this.props}
            updateLanguage={this.updateLanguage}
            locale={this.state.locale}
          />
        </IntlProvider>
      )
    }
  }
  return ReactIntlContainer
}

export default withI18n
